// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"30eb8a80","743":"cd2e5ccd"}[chunkId] + ".chunk.js";
};